import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, InputGroup, Image } from 'react-bootstrap';
import { FaUser, FaLock } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Login.css'
import Logo from '../Images/logo.png';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = { username, password };

        try {
            const response = await fetch('https://gwcapi.emedha.in/auth/api/admin/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            });

            const result = await response.json();

            if (response.ok) {
                navigate('/dash-bo/ard-dash/board/346734/dashboard');
            } else {
                setError(result.message || 'Login failed');
            }
        } catch (err) {
            console.error('Error:', err);
            setError('An error occurred. Please try again.');
        }
    };

    return (
        <div className="login-bg">
            <Container fluid className="d-flex justify-content-center align-items-center vh-100">
                <motion.div 
                    initial={{ opacity: 0, scale: 0.8 }} 
                    animate={{ opacity: 1, scale: 1 }} 
                    transition={{ duration: 0.6 }}
                    className="login-card"
                >
                     <Row className="align-items-center justify-content-center mb-4">
                        <Col xs="auto">
                            <Image src={Logo} alt="Golden Women Logo" className="logo-img" />
                        </Col>
                        <Col xs="auto">
                            <h2 className="text-center">Golden Women</h2>
                        </Col>
                    </Row>

                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="username" className="mb-3">
                            <InputGroup>
                                <InputGroup.Text className="input-icon"><FaUser /></InputGroup.Text>
                                <Form.Control 
                                    type="text"
                                    placeholder="Username"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    required
                                />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group controlId="password" className="mb-3">
                            <InputGroup>
                                <InputGroup.Text className="input-icon"><FaLock /></InputGroup.Text>
                                <Form.Control 
                                    type="password"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </InputGroup>
                        </Form.Group>

                        {error && <p className="text-danger text-center">{error}</p>}

                        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                            <Button type="submit" className="w-100 login-button">Login</Button>
                        </motion.div>
                    </Form>
                </motion.div>
            </Container>
        </div>
    );
};

export default Login;
